import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal as AriaModal, Dialog, Button } from 'react-aria-components';

/**
 * A component for displaying content in an overlay context
 */
function Modal({ isOpen, title, children, onOpenChange }) {
  const { t } = useTranslation();

  return (
    <AriaModal isOpen={isOpen} onOpenChange={onOpenChange}>
      <Dialog
        className={classNames('modal', {
          'modal--open': isOpen
        })}
      >
        <div className="modal__content">
          <div className="modal__header">
            <Button className={'button--secondary button--icon icon--cross'} onPress={onOpenChange}>
              {t('styleguide:close')}&nbsp;
              <span className={'visually-hidden'}>{`${title} ${t('styleguide:modal')}`}</span>
            </Button>
            <h2 className="header__content">{title}</h2>
          </div>
          <div className="content__content">{children}</div>
        </div>
      </Dialog>
    </AriaModal>
  );
}

Modal.propTypes = {
  /**
   * The flag for showing the modal
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * The title of the modal
   */
  title: PropTypes.string,
  /**
   * The function called when closing the modal
   */
  onOpenChange: PropTypes.func,
  /**
   * The nested children
   */
  children: PropTypes.node
};

export default Modal;
